import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarService, Doddle } from '@doddly/core';
import { IconComponent } from '../icon/icon.component';
import { PostComponent } from '../post/post.component';
import { DragDropModule } from 'primeng/dragdrop';

@Component({
  selector: 'ly-drafts-panel',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    PostComponent,
    DragDropModule,
    IconComponent,
  ],
  templateUrl: './drafts-panel.component.html',
  styleUrl: './drafts-panel.component.scss',
})
export class DraftsPanelComponent implements AfterViewInit, OnDestroy {
  @ViewChild('draftsPanel') overlayPanel!: OverlayPanel;
  @Input() drafts: Doddle[] = [];

  private calendarService = inject(CalendarService);
  private renderer = inject(Renderer2);

  ngAfterViewInit() {
    this.renderer.listen('window', 'scroll', this.onScroll);
  }

  ngOnDestroy() {
    this.renderer.listen('window', 'scroll', this.onScroll);
  }

  onDragStart(doddle: Doddle) {
    this.calendarService.draggedPost.set(doddle);
    this.updatePanelSize();
  }

  onDrop() {
    this.calendarService.drop(null);
    this.updatePanelSize();
  }

  onDragging() {
    this.overlayPanel.hide();
  }

  updatePanelSize() {
    if (this.overlayPanel && this.overlayPanel.container) {
      const panelHeight = this.overlayPanel.container.scrollHeight;
      this.overlayPanel.container.style.height = `${panelHeight}px`;
    }
  }

  // Close the overlay panel when the user scrolls
  onScroll = (event: Event) => {
    if (
      this.overlayPanel?.overlayVisible &&
      !(
        this.overlayPanel.container &&
        this.overlayPanel.container.contains(event.target as Node)
      )
    ) {
      this.overlayPanel.hide();
    }
  };
}
